//----------
// i-mobile広告 定数定義
// @note 公開識別子のため、直接埋め込みで問題なし
//----------

// -- PC向け -- //

// バナー広告（468x60）
export const AD_ELEMENT_ID_BANNER_1 = "im-c8ed2c6168924cb68b41d7d4273cdb79";
export const ASID_BANNER_1 = 1923032;

// ビッグバナー広告（728x90）
export const AD_ELEMENT_ID_BIG_BANNER_1 = "im-5060f7a9947e4443b9696e9ca30f7f84";
export const ASID_BIG_BANNER_1 = 1923033;
export const AD_ELEMENT_ID_BIG_BANNER_2 = "im-cbe3aec549ae4bd59b3c8e2dc42072e1";
export const ASID_BIG_BANNER_2 = 1923036;

// ワイドスカイスクレイパー広告（160x600）
export const AD_ELEMENT_ID_WIDE_SKYSCRAPER_1 = "im-409dc7cd509046cb8ebaad2aac41539e";
export const ASID_WIDE_SKYSCRAPER_1 = 1923034;


// -- スマホ向け -- //

// スマホ用ビッグバナー広告（320x50）
export const AD_ELEMENT_ID_SP_BIG_BANNER_1 = "im-957326c0c6f64d3bb16cddfe6ab45711";
export const ASID_SP_BIG_BANNER_1 = 1923041;
export const AD_ELEMENT_ID_SP_BIG_BANNER_2 = "im-1d7977627f7a4663a1389a91da14e404";
export const ASID_SP_BIG_BANNER_2 = 1923042;

// ABC広告（320x100）
export const AD_ELEMENT_ID_ABC_1 = "im-5fe41b816e734254970ae045e2dd48fc";
export const ASID_ABC_1 = 1923041;
